var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"size":"mini","icon":"el-icon-document-copy"},on:{"click":_vm.copy}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }